import { MRT_RowData, MRT_TableInstance } from 'mantine-react-table';
import { formatDate } from 'src/utils/format';

export interface IExportToolbarActionProps<
  TData extends MRT_RowData = MRT_RowData,
> {
  table: MRT_TableInstance<TData>;
  transform?: (
    data: TData[],
  ) => { [key: string]: string | number | boolean | null | undefined }[];
  filename?: string;
}

export interface IPreparedTableExport {
  data: { [key: string]: string | number | boolean | null | undefined }[];
  filename: string;
}

/** @registry Extracts a DataTable's pre-pagination rows, applies the optional export transform, and builds the timestamped base filename for the CSV toolbar export action. */
export const prepareTableExport = <TData extends MRT_RowData>(
  table: MRT_TableInstance<TData>,
  transform: IExportToolbarActionProps<TData>['transform'],
  filename: string | undefined,
): IPreparedTableExport => {
  const rawData = table.getPrePaginationRowModel().rows.map((r) => r.original);
  const data = transform ? transform(rawData) : rawData;
  return {
    data,
    filename: `${filename ?? 'export'}-${formatDate(
      new Date(),
      'MM-DD-YYYY_HH_mm',
    )}`,
  };
};
